// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__3mQne","column":"Flex_column__3bKNb","inline":"Flex_inline__eBLnH","start":"Flex_start__r0bum","wrap":"Flex_wrap__3HU7S"};